import { gql } from '../../__generated__/gql'

export const RESEND_INVITATION_BY_EMAIL_MUTATION = gql(`
  mutation resendInvitationByEmail($email: String!) {
    resendInvitationByEmail(input: { email: $email }) {
      success
      message
    }
  }
`)
